import { render, staticRenderFns } from "./questionentry.vue?vue&type=template&id=42908ac6"
import script from "./questionentry.vue?vue&type=script&lang=js"
export * from "./questionentry.vue?vue&type=script&lang=js"
import style0 from "./questionentry.vue?vue&type=style&index=0&id=42908ac6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports